/* With A Scratch — shared section JS */
(function () {
  'use strict';

  // Smooth open/close for FAQ <details> accordions.
  // Only one item open at a time per group.
  function initFaqGroups() {
    document.querySelectorAll('[data-was-faq]').forEach(function (group) {
      if (group.dataset.wasFaqInit) return;
      group.dataset.wasFaqInit = 'true';

      group.querySelectorAll('details.was-faq__item').forEach(function (details) {
        var summary = details.querySelector('summary');
        var content = details.querySelector('.was-faq__content');
        if (!summary || !content) return;

        summary.addEventListener('click', function (event) {
          event.preventDefault();

          if (details.open) {
            collapse(details, content);
          } else {
            group.querySelectorAll('details[open]').forEach(function (other) {
              if (other !== details) {
                collapse(other, other.querySelector('.was-faq__content'));
              }
            });
            expand(details, content);
          }
        });
      });
    });
  }

  function expand(details, content) {
    details.open = true;
    var height = content.scrollHeight;
    content.style.maxHeight = '0px';
    content.style.transition = 'max-height 0.3s ease';
    requestAnimationFrame(function () {
      content.style.maxHeight = height + 'px';
    });
    content.addEventListener('transitionend', function handler() {
      content.style.maxHeight = '';
      content.style.transition = '';
      content.removeEventListener('transitionend', handler);
    });
  }

  function collapse(details, content) {
    if (!content) {
      details.open = false;
      return;
    }
    content.style.maxHeight = content.scrollHeight + 'px';
    content.style.transition = 'max-height 0.3s ease';
    requestAnimationFrame(function () {
      content.style.maxHeight = '0px';
    });
    content.addEventListener('transitionend', function handler() {
      details.open = false;
      content.style.maxHeight = '';
      content.style.transition = '';
      content.removeEventListener('transitionend', handler);
    });
  }

  // Header: mobile drawer + desktop dropdowns.
  function initHeaders() {
    document.querySelectorAll('[data-was-header]').forEach(function (header) {
      if (header.dataset.wasHeaderInit) return;
      header.dataset.wasHeaderInit = 'true';

      var drawer = header.querySelector('.was-header__drawer');
      var overlay = header.querySelector('.was-header__overlay');
      var openBtn = header.querySelector('[data-was-drawer-open]');

      function setDrawer(open) {
        if (!drawer || !overlay) return;
        drawer.hidden = !open;
        overlay.hidden = !open;
        document.body.style.overflow = open ? 'hidden' : '';
      }

      var searchPanel = header.querySelector('[data-was-search]');
      var searchInput = header.querySelector('[data-was-search-input]');
      var searchOpenBtns = header.querySelectorAll('[data-was-search-open]');

      function setSearch(open) {
        if (!searchPanel) return;
        searchPanel.hidden = !open;
        header.classList.toggle('is-search-open', open);
        searchOpenBtns.forEach(function (btn) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        if (open) {
          setDrawer(false);
          if (searchInput) {
            window.setTimeout(function () { searchInput.focus(); }, 10);
          }
        }
      }

      searchOpenBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setSearch(true);
        });
      });
      header.querySelectorAll('[data-was-search-close]').forEach(function (el) {
        el.addEventListener('click', function () { setSearch(false); });
      });

      if (openBtn) {
        openBtn.addEventListener('click', function () {
          setSearch(false);
          setDrawer(true);
        });
      }
      header.querySelectorAll('[data-was-drawer-close]').forEach(function (el) {
        el.addEventListener('click', function () { setDrawer(false); });
      });

      header.querySelectorAll('[data-was-dropdown]').forEach(function (dropdown) {
        var toggle = dropdown.querySelector('[data-was-dropdown-toggle]');
        var panel = dropdown.querySelector('.was-header__panel');
        if (!toggle) return;
        function setOpen(open) {
          dropdown.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        toggle.addEventListener('click', function (event) {
          event.stopPropagation();
          setOpen(!dropdown.classList.contains('is-open'));
        });
        toggle.addEventListener('mouseenter', function () { setOpen(true); });
        if (panel) {
          panel.addEventListener('mouseleave', function () { setOpen(false); });
        }
      });

      document.addEventListener('click', function (event) {
        header.querySelectorAll('[data-was-dropdown].is-open').forEach(function (dropdown) {
          if (!dropdown.contains(event.target)) {
            dropdown.classList.remove('is-open');
            var toggle = dropdown.querySelector('[data-was-dropdown-toggle]');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          }
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          setDrawer(false);
          setSearch(false);
          header.querySelectorAll('[data-was-dropdown].is-open').forEach(function (dropdown) {
            dropdown.classList.remove('is-open');
            var toggle = dropdown.querySelector('[data-was-dropdown-toggle]');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          });
        }
      });
    });
  }

  function initContactForms() {
    document.querySelectorAll('[data-was-contact-form]').forEach(function (form) {
      if (form.dataset.wasContactInit) return;
      form.dataset.wasContactInit = 'true';

      var messages = {
        name: 'Name is required',
        email: 'Email is required',
        emailInvalid: 'Enter a valid email',
        subject: 'Please select a subject',
        message: 'Message is required'
      };

      function showError(key, text) {
        var input = form.querySelector('[data-was-contact-input="' + key + '"]');
        var error = form.querySelector('[data-was-contact-error="' + key + '"]');
        if (input) input.classList.add('is-error');
        if (error) {
          error.textContent = text;
          error.hidden = false;
        }
      }

      function clearError(key) {
        var input = form.querySelector('[data-was-contact-input="' + key + '"]');
        var error = form.querySelector('[data-was-contact-error="' + key + '"]');
        if (input) input.classList.remove('is-error');
        if (error) {
          error.textContent = '';
          error.hidden = true;
        }
      }

      function validate() {
        var valid = true;
        var name = form.querySelector('[data-was-contact-input="name"]');
        var email = form.querySelector('[data-was-contact-input="email"]');
        var subject = form.querySelector('[data-was-contact-input="subject"]');
        var message = form.querySelector('[data-was-contact-input="message"]');

        ['name', 'email', 'subject', 'message'].forEach(clearError);

        if (!name || !name.value.trim()) {
          showError('name', messages.name);
          valid = false;
        }
        if (!email || !email.value.trim()) {
          showError('email', messages.email);
          valid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
          showError('email', messages.emailInvalid);
          valid = false;
        }
        if (!subject || !subject.value) {
          showError('subject', messages.subject);
          valid = false;
        }
        if (!message || !message.value.trim()) {
          showError('message', messages.message);
          valid = false;
        }
        return valid;
      }

      form.addEventListener('submit', function (event) {
        if (!validate()) event.preventDefault();
      });

      form.querySelectorAll('[data-was-contact-input]').forEach(function (input) {
        input.addEventListener('input', function () {
          clearError(input.getAttribute('data-was-contact-input'));
        });
        input.addEventListener('change', function () {
          clearError(input.getAttribute('data-was-contact-input'));
        });
      });
    });
  }

  function initSignupPopups() {
    document.querySelectorAll('[data-was-signup-popup]').forEach(function (root) {
      if (root.dataset.wasSignupInit) return;
      root.dataset.wasSignupInit = 'true';

      var storageKey = root.getAttribute('data-storage-key') || 'wasSignupPopup';
      var pendingKey = storageKey + ':pending';
      var delay = parseInt(root.getAttribute('data-delay'), 10) || 1200;
      var isSuccess = root.getAttribute('data-success') === 'true';
      var alreadySubscribed = root.getAttribute('data-already-subscribed') === 'true';
      var designMode = window.Shopify && Shopify.designMode;

      function readStore() {
        try {
          var local = window.localStorage.getItem(storageKey);
          if (local) return local;
        } catch (err) { /* ignore */ }
        var match = document.cookie.match(new RegExp('(?:^|; )' + storageKey + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
      }

      function persist(reason) {
        if (designMode || !reason) return;
        try { window.localStorage.setItem(storageKey, reason); } catch (err) { /* ignore */ }
        document.cookie = storageKey + '=' + encodeURIComponent(reason) +
          '; path=/; max-age=31536000; SameSite=Lax';
      }

      function clearPending() {
        try { window.sessionStorage.removeItem(pendingKey); } catch (err) { /* ignore */ }
      }

      function markPending() {
        try { window.sessionStorage.setItem(pendingKey, '1'); } catch (err) { /* ignore */ }
      }

      function wasPending() {
        try { return window.sessionStorage.getItem(pendingKey) === '1'; } catch (err) { return false; }
      }

      var form = root.querySelector('form');
      var hasErrors = !!root.querySelector('[data-was-signup-errors]');

      if (form) {
        form.addEventListener('submit', function () {
          markPending();
        });
      }

      function openPopup() {
        if (root.parentNode !== document.body) {
          document.body.appendChild(root);
        }
        root.hidden = false;
        root.inert = false;
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var input = root.querySelector('.was-signup-popup__input');
        if (input) {
          setTimeout(function () { input.focus(); }, 80);
        }
      }

      function closePopup(reason) {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        root.inert = true;
        root.hidden = true;
        document.body.style.overflow = '';
        persist(reason);
      }

      root.querySelectorAll('[data-was-signup-dismiss]').forEach(function (el) {
        el.addEventListener('click', function () {
          closePopup('dismissed');
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && root.classList.contains('is-open')) {
          closePopup('dismissed');
        }
      });

      var copyBtn = root.querySelector('[data-was-signup-copy]');
      var codeEl = root.querySelector('[data-was-signup-code]');
      if (copyBtn && codeEl) {
        copyBtn.addEventListener('click', function () {
          var code = codeEl.textContent.trim();
          var original = copyBtn.textContent;
          function done() {
            copyBtn.textContent = 'Copied';
            setTimeout(function () { copyBtn.textContent = original; }, 1600);
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done).catch(done);
          } else {
            done();
          }
        });
      }

      if (designMode) {
        openPopup();
        return;
      }

      var hasSuccessUi = !!root.querySelector('[data-was-signup-success]');

      if (alreadySubscribed && !isSuccess && !hasSuccessUi && !wasPending() && !hasErrors) {
        persist('subscribed');
        return;
      }

      if (isSuccess || hasSuccessUi) {
        persist('subscribed');
        clearPending();
        openPopup();
        return;
      }

      if (hasErrors) {
        clearPending();
        openPopup();
        return;
      }

      if (wasPending()) {
        persist('subscribed');
        clearPending();
        window.location.replace('/?was_signup=1');
        return;
      }

      if (readStore()) return;

      setTimeout(openPopup, delay);
    });
  }

  function initAll() {
    initFaqGroups();
    initHeaders();
    initContactForms();
    initSignupPopups();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor re-renders a section.
  document.addEventListener('shopify:section:load', initAll);
})();
